import * as clipboard from '@attain-apps/fe/web/main/lib/clipboard'

import type { CreateEntity } from './types'

/**
 * Used to copy and paste rules. E.g., from one scenario into another
 */
export class ClipboardItem extends clipboard.models.Item<CreateEntity> {
  constructor(params: clipboard.models.Item.constructor.Params<CreateEntity>) {
    super(params)
  }

  /** @inheritdoc */
  public override getName(): string {
    return this.payload.name
  }
}
